import React from 'react';
import '../statics/stylesheet.css';
import '../statics/marketplace.css';

class MarketplaceItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      displayedItems: 12
    };
  }

  componentDidMount() {
    this.fetchMarketplaceData();
    window.scrollTo(0, 0);
  }

  fetchMarketplaceData = () => {
    const formData = new FormData();
    formData.append('action', 'list');
    
    fetch('https://soratwheels.ca/apii/packagelist.php', {
      method: 'POST',
      body: formData
    })
      .then(response => response.json())
      .then(result => {
        const data = result.data || [];
        this.setState({
          data: data,
          loading: false
        });
      })
      .catch(error => {
        console.error('Error fetching marketplace data:', error);
        this.setState({ loading: false });
      });
  }

  loadMore = () => {
    this.setState(prevState => ({
      displayedItems: prevState.displayedItems + 12
    }));
  }

  openProductLink = (link) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  }

  renderMarketplaceItem = (item) => {
    return (
      <div key={item.id} className="marketplace-item">
        <div className="marketplace-image-container">
          <img 
            src={item.image_url}
            alt={item.title}
            className="marketplace-image"
            onError={(e) => {
              e.target.src = window.baseUrl + '/media/soratimg.jpg';
            }}
          />
        </div>
        <h3 className="marketplace-title">{item.title}</h3>
        <p className="marketplace-price">{item.price}</p>
        <button 
          className="marketplace-link-btn"
          onClick={() => this.openProductLink(item.product_link)}
        >
          View Package
        </button>
      </div>
    );
  }

  render() {
    const { loading, data, displayedItems } = this.state;

    if (loading) {
      return (
        <div className="marketplace-loading">
          <div className="content-divLength">
            {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
              <img src={window.host + '/statics/img/loading.svg'} alt="Loading" /> :
              <img src={window.host + '/statics/img/loading.gif'} alt="Loading" />}
          </div>
        </div>
      );
    }

    const itemsToShow = data.slice(0, displayedItems);
    const hasMore = displayedItems < data.length;

    return (
      <div className="marketplace-container">
        <h1 className="marketplace-main-title">Facebook Marketplace Packages</h1>
        
        <div className="marketplace-grid">
          {itemsToShow.map(item => this.renderMarketplaceItem(item))}
        </div>

        {itemsToShow.length === 0 && (
          <div className="marketplace-no-results">
            <p>No items found</p>
          </div>
        )}

        {hasMore && (
          <div className="marketplace-load-more-container">
            <button className="marketplace-load-more-btn" onClick={this.loadMore}>
              Load More
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default MarketplaceItems;




// WEBPACK FOOTER //
// ./src/components/MarketplaceItems.js